/* Studio Vintage — animations page d'accueil (GSAP)
   Trois modules autonomes : hero parallax + reveal, maisons marquee, hero slideshow.
   Chargé en `defer` après GSAP : le DOM est prêt et `gsap` est défini. */

/* ──────────────────────────────────────────────────────────────────────────
   Hero : reveal du texte au load + parallax doux des photos au scroll.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  if (typeof gsap === 'undefined') return;
  if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);

  var hero   = document.querySelector('.hero');
  var images = document.querySelectorAll('.hero__image');
  var text   = document.querySelector('.hero__text');
  var ctas   = document.querySelector('.hero__ctas');
  if (!hero || !images.length || !text) return;

  var mm = gsap.matchMedia();
  mm.add({
    isDesktop: '(min-width: 721px)',
    isMobile:  '(max-width: 720px)',
    reduce:    '(prefers-reduced-motion: reduce)'
  }, function (context) {
    var c        = context.conditions || {};
    var reduce   = !!c.reduce;
    var isMobile = !!c.isMobile;

    if (reduce) {
      gsap.set(images, { scale: 1 });
      gsap.set(text,   { opacity: 1, y: 0 });
      if (ctas) gsap.set(ctas, { opacity: 1, y: 0 });
      return;
    }

    gsap.set(images, { scale: 1, transformOrigin: 'center center' });
    gsap.set(text,   { opacity: 0, y: 14 });
    if (ctas) gsap.set(ctas, { opacity: 0, y: 12 });

    gsap.to(text, {
      opacity: 1, y: 0,
      duration: 0.9, ease: 'power2.out', delay: 0.2
    });
    if (ctas) gsap.to(ctas, {
      opacity: 1, y: 0,
      duration: 0.8, ease: 'power2.out', delay: 0.45
    });

    gsap.to(images, {
      yPercent: isMobile ? 4    : 6,
      scale:    isMobile ? 1.05 : 1.06,
      ease: 'none',
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end:   'bottom top',
        scrub: true
      }
    });
  });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    }, 180);
  });

  window.addEventListener('beforeunload', function () { mm.revert(); });
})();

/* ──────────────────────────────────────────────────────────────────────────
   Maisons : deux rubans horizontaux, hybride scroll-driven + autoplay idle.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  if (typeof gsap === 'undefined') return;
  var section = document.querySelector('.maisons');
  if (!section) return;
  var rowA = section.querySelector('.maisons__band--a .maisons__row');
  var rowB = section.querySelector('.maisons__band--b .maisons__row');
  if (!rowA || !rowB) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function topup(row) {
    var originals = Array.prototype.slice.call(row.children).filter(function (el) {
      return !el.hasAttribute('aria-hidden');
    });
    if (!originals.length) return;
    var safety = 8;
    while (
      (row.scrollWidth < window.innerWidth * 2.1 || row.children.length < originals.length * 2)
      && safety-- > 0
    ) {
      originals.forEach(function (orig) {
        var clone = orig.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        row.appendChild(clone);
      });
    }
  }
  topup(rowA);
  topup(rowB);

  function stepOf(row) {
    var originals = Array.prototype.slice.call(row.children).filter(function (el) {
      return !el.hasAttribute('aria-hidden');
    }).length;
    return originals ? (100 * originals / row.children.length) : 50;
  }
  var stepA = stepOf(rowA);
  var stepB = stepOf(rowB);

  var stateA = 0;
  var stateB = -stepB;
  var targetA = stateA;
  var targetB = stateB;
  var setA = gsap.quickSetter(rowA, 'xPercent');
  var setB = gsap.quickSetter(rowB, 'xPercent');
  setA(stateA);
  setB(stateB);

  function wrap(v, step) {
    v = v % step;
    if (v > 0) v -= step;
    return v;
  }

  var autoSpeedA = stepA / 110;
  var autoSpeedB = stepB / 110;
  var scrollFactorA = stepA / (window.innerHeight * 7);
  var scrollFactorB = stepB / (window.innerHeight * 7);
  var smoothing = 4.0;

  var idle = false;
  var idleTimer = setTimeout(function () { idle = true; }, 1000);
  var lastScrollY = window.scrollY;

  gsap.ticker.add(function (_time, deltaTime) {
    var dt = deltaTime / 1000;
    if (dt <= 0) return;

    if (idle) {
      targetA -= autoSpeedA * dt;
      targetB += autoSpeedB * dt;
    }

    var k = 1 - Math.exp(-smoothing * dt);
    stateA += (targetA - stateA) * k;
    stateB += (targetB - stateB) * k;

    setA(wrap(stateA, stepA));
    setB(wrap(stateB, stepB));

    if (stateA < -stepA * 1000) {
      var nA = Math.floor(stateA / stepA) * stepA;
      stateA -= nA; targetA -= nA;
    }
    if (stateB < -stepB * 1000) {
      var nB = Math.floor(stateB / stepB) * stepB;
      stateB -= nB; targetB -= nB;
    }
  });

  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    var dy = y - lastScrollY;
    lastScrollY = y;

    targetA -= dy * scrollFactorA;
    targetB += dy * scrollFactorB;

    idle = false;
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function () { idle = true; }, 1000);
  }, { passive: true });

  var resizeT = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () {
      scrollFactorA = stepA / (window.innerHeight * 7);
      scrollFactorB = stepB / (window.innerHeight * 7);
      topup(rowA);
      topup(rowB);
      stepA = stepOf(rowA);
      stepB = stepOf(rowB);
      autoSpeedA = stepA / 110;
      autoSpeedB = stepB / 110;
    }, 180);
  });
})();

/* ──────────────────────────────────────────────────────────────────────────
   Hero slideshow auto : cycle 1 → 2 → 3 → 1 toutes les 5 secondes.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  if (typeof gsap === 'undefined') return;
  var hero = document.querySelector('.hero');
  if (!hero) return;
  var slides = hero.querySelectorAll('.hero__slide');
  if (slides.length < 2) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  gsap.set(slides, { xPercent: 100 });
  gsap.set(slides[0], { xPercent: 0 });

  var current = 0;
  var intervalMs = 5000;
  var transitionMs = 1100;
  var timer = null;
  var animating = false;

  function tick() {
    if (animating) return;
    var next = (current + 1) % slides.length;

    gsap.set(slides[next], { xPercent: 100 });

    slides[next].removeAttribute('aria-hidden');
    slides[current].setAttribute('aria-hidden', 'true');

    animating = true;
    var tl = gsap.timeline({
      onComplete: function () {
        gsap.set(slides[current], { xPercent: 100 });
        current = next;
        animating = false;
      }
    });
    tl.to(slides[current], {
      xPercent: -100,
      duration: transitionMs / 1000,
      ease: 'power3.inOut'
    }, 0);
    tl.to(slides[next], {
      xPercent: 0,
      duration: transitionMs / 1000,
      ease: 'power3.inOut'
    }, 0);
  }

  function start() {
    if (timer) return;
    timer = setInterval(tick, intervalMs);
  }
  function stop() {
    if (!timer) return;
    clearInterval(timer);
    timer = null;
  }

  start();

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });
})();
